// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__2tueA","buttonIndietro":"Navigation_buttonIndietro__6NfzK","buttonContinua":"Navigation_buttonContinua__yw67c"};